import { FC } from "react";
import currencySmallIcon from "../../icons/currency-small.png";
import styles from "./CurrencySmallIcon.module.scss";
import { formatNumberWithSpaces, shortNumberForm } from "../../utils/numbers";

export interface ICurrencySmallIconProps {
    value?: number;
    compact?: boolean;
}

export const CurrencySmallIcon: FC<ICurrencySmallIconProps> = ({ value = 0, compact }) => {
    const shouldDisplayValue = !isNaN(value) && value > 0;
    
    return (
        <span className={styles.field}>
            <img 
                src={currencySmallIcon} 
                alt="Currency Icon" 
                className={styles.currencyIcon} 
            />
            {shouldDisplayValue && (
                <>
                    {' '}
                    { compact ? shortNumberForm(value, 1) : formatNumberWithSpaces(value) }
                </>
            )}
        </span>
    );
};